import React from "react";
import UniAutocomplete, {UniAutocompleteItem} from "../../../../../@WUM/core/Elements/Form/Elements/UniAutocomplete";
import {IntlMessage} from "../../../../../@WUM/core/Elements";
import {AllUser} from "../../../API/response/settingstimetracking";

interface UserSelectProps {
    value: any;
    name: string;
    onChange: (name: string, selected: UniAutocompleteItem[]) => void;
    disabled?: boolean;
    placeholder?: string;
}

const UserSelect: React.FC<UserSelectProps> = (props) => {
    const toSelected = (val: any): UniAutocompleteItem[] =>
        Array.isArray(val)
            ? val
                .filter((item: any) => item.user)
                .map((item: any) => ({
                    value: String(item.user.id),
                    text: `${item.user.first_name} ${item.user.last_name}`,
                }))
            : [];

    const selectableRaw  = AllUser();
    const items: UniAutocompleteItem[] = Array.isArray(selectableRaw)
        ? selectableRaw.map((u) => ({ value: String(u.value), text: u.text }))
        : [];

    const [selected, setSelected] = React.useState<UniAutocompleteItem[]>(toSelected(props.value));
    React.useEffect(() => {
        setSelected(toSelected(props.value));
    }, [props.value]);

    const handleChange = (next: UniAutocompleteItem[]) => {
        setSelected(next);
        props.onChange(props.name, next);
    };

    if (items.length === 0) return <div />;

    return (
        <>
            <h5 className={"pb-2"}>
                {IntlMessage({locale: 'de', messageId: 'time.settings.' + props.name, Store: ''})}
            </h5>
            <UniAutocomplete
                id={`uni-autocomplete-${props.name}`}
                key={`uni-autocomplete-${props.name}`}
                items={items}
                value={selected}
                onChange={handleChange}
                name={props.name}
                disabled={props.disabled}
                placeholder={props.placeholder || "Benutzer auswählen"}
            />
        </>
    );
};

export default UserSelect;
